import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';


export default class CloseOutWorked extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Scope
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Deliverables targeted:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.w_targeted}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Deliverables completed:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.w_completed}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Effectiveness(%):</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.w_effectiveness}
            </Typography>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CloseOutScope.js